import { createSlice } from "@reduxjs/toolkit";
import { SelectFieldType } from "../../common/types/Types";

interface QualificationListInterface {
    currentPage?: number;
    searchTerm?: string;
    itemsPerPage?: number;
    itemsPerPageSelect: { value: number; activeValue: boolean }[];
    qualificationStandardFilter?: SelectFieldType;
    functionGroupFilter?: SelectFieldType;
    achievedFilter?: SelectFieldType | null;
    prefillFilter?: string;
    sort?: {
        sortName: string;
        isSorted: boolean;
    };
}

const initialState: QualificationListInterface = {
    currentPage: 1,
    searchTerm: "",
    itemsPerPage: 12,
    itemsPerPageSelect: [
        { value: 12, activeValue: true },
        { value: 25, activeValue: false },
        { value: 50, activeValue: false },
    ],
    achievedFilter: null,
    sort: {
        sortName: "",
        isSorted: false,
    },
};

const QualificationListSlice = createSlice({
    name: "qualificationList",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.itemsPerPage = action.payload;
            state.itemsPerPageSelect = state.itemsPerPageSelect.map((item) => ({
                ...item,
                activeValue: item.value === action.payload,
            }));
        },
        setQualificationStandardFilter: (state, action) => {
            state.qualificationStandardFilter = action.payload;
        },
        setFunctionGroupFilter: (state, action) => {
            state.functionGroupFilter = action.payload;
        },
        setAchievedFilter: (state, action) => {
            state.achievedFilter = action.payload;
        },
        setPrefillFilter: (state, action) => {
            state.prefillFilter = action.payload;
        },
        setSort: (state, action) => {
            state.sort = action.payload;
        },
    },
});

export const qualificationListReducer = QualificationListSlice.reducer;
export const {
    setItemsPerPage,
    setCurrentPage,
    setSearchTerm,
    setFunctionGroupFilter,
    setQualificationStandardFilter,
    setAchievedFilter,
    setPrefillFilter,
    setSort,
} = QualificationListSlice.actions;
